import { RestMethod } from "app/_helpers/ApiConfig/RestMethod";

// import { RestMethod } from '../../_helpers/ApiConfig/RestMethod'
// import FilterResponse from '../../_helpers/FilterResponse'
// import toastr from 'toastr'

export const StateService = {
    getState,
    getStateByID,
    createState,
    updateState,
    deleteState,
    getStateAll
}


async function getState(projectID) {

    try {
        const response = await RestMethod.GET('/global-configuration/state?filter[status]=1');
        return response.data;
    }
    catch (error) {
        console.log("error detected while fetching data from api");
        return null;
    }
}

async function getStateAll(projectID) {

    try {
        const response = await RestMethod.GET('/global-configuration/state/all-state');
        return response.data;
    }
    catch (error) {
        console.log("error detected while fetching data from api");
        return null;
    }
}

async function getStateByID(projectID, id) {
    try {
        const response = await RestMethod.GET('/global-configuration/state/' + id);
        return response.data;
    }
    catch (error) {
        console.log("error detected while fetching data from api");
        return null;
    }
}


async function createState(projectID, data) {
    try {
        const response = await RestMethod.POST('/global-configuration/state', data);
        return response.data;
    }
    catch (error) {
        console.log("error detected while fetching data from api");
        return null;
    }
}

async function updateState(projectID, id, data) {
    try {
        const response = await RestMethod.PUT('/global-configuration/state/' + id, data);
        return response.data;
    }
    catch (error) {
        console.log("error detected while fetching data from api");
        return null;
    }
}

async function deleteState(projectID, id, data) {
    try {
        const response = await RestMethod.DELETE('/global-configuration/state/' + id, data);
        return response.data;
    }
    catch (error) {
        console.log("error detected while fetching data from api");
        return null;
    }
}
